import {
  SET_CONSENT_PROPS
} from '../const/action_types.js';


export const setConsentProps = (consentProps)=> {
  return { type: SET_CONSENT_PROPS, consentProps };
};
